import { render, staticRenderFns } from "./EvolutionHectareChart.vue?vue&type=template&id=5d49831d&scoped=true"
import script from "./EvolutionHectareChart.vue?vue&type=script&lang=js"
export * from "./EvolutionHectareChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49831d",
  null
  
)

export default component.exports